import states from '@/data/states'
import stories from '@/data/stories'

export default {
  loadStory: ({ commit }, id) => {
    const story = stories.find(story => story.id === id)
    const state = states.find(state => state.name === story.scene)
    const data = { ...story, index: 0 }
    commit('SELECT_STORY', id)
    commit('LOAD_SCENE', { ...state, data })
  },
  loadScene: ({ commit }, { name, data = null }) => {
    const state = states.find(state => state.name === name)
    commit('LOAD_SCENE', { ...state, data })
  },
  updateScene: ({ commit }, data) => {
    commit('UPDATE_SCENE', data)
  },
  selectPlayer: ({ commit }, player) => {
    commit('SELECT_PLAYER', player)
  },
  selectCharacter: ({ commit, state }, character) => {
    if (state.character !== character) {
      commit('SELECT_CHARACTER', character)
    }
  },
  selectStory: ({ commit }, id) => {
    commit('SELECT_STORY', id)
  },
  pause: ({ commit }) => {
    commit('PAUSE')
  },
  resume: ({ commit }) => {
    commit('RESUME')
  },
  reset: ({ commit }) => {
    commit('RESET')
  }
}
